import React from 'react';
import { Icon, Table, Tooltip, Modal } from 'antd';
import { useEditEmailTypesStore } from './store';
import moment from 'moment';
import PermissionGuard from '../../../components/miscellaneous/PermissionGuard';
import { useDeleteEmailType } from '../../../mutation/mail';

export default function EmailTypesTable() {
  const { emailTypes } = useEditEmailTypesStore();
  const { mutate, isLoading } = useDeleteEmailType();
  const columnDefs = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
    },
    {
      title: 'Internal Name',
      dataIndex: 'type',
      key: 'type',
      width: 150,
    },
    {
      title: 'Public Facing Name',
      dataIndex: 'publicName',
      key: 'publicName',
      width: 180,
    },
    {
      title: 'Show Preferences UI',
      dataIndex: 'unsubscriptionCustomizable',
      align: 'center',
      key: 'unsubscriptionCustomizable',
      render: data => {
        return data ? 'Yes' : 'No';
      },
    },
    {
      title: 'Number of templates',
      dataIndex: 'templateCounts',
      key: 'templateCounts',
      align: 'center',
    },
    {
      title: 'Throttle Type',
      dataIndex: 'throttleType',
      key: 'throttleType',
      align: 'center',
    },
    {
      title: 'Short Term Throttling',
      dataIndex: 'shortTermThrottling',
      key: 'shortTermThrottling',
      align: 'center',
    },
    {
      title: 'Long Term Throttling',
      dataIndex: 'longTermThrottling',
      key: 'longTermThrottling',
      align: 'center',
    },
    {
      title: 'Relaxed Throttling',
      dataIndex: 'relaxedThrottling',
      key: 'relaxedThrottling',
      align: 'center',
    },
    {
      title: 'Created At',
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: data => {
        return moment(data).format('YYYY-MM-DD');
      },
      width: 150,
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (data, row) => {
        return (
          <PermissionGuard requiredPermission="mail.types.modify">
            <Tooltip
              title={
                row.templateCounts
                  ? 'Cannot delete email types with associated email templates'
                  : null
              }
            >
              <Icon
                style={{
                  fontSize: 16,
                  opacity: row.templateCounts ? 0.4 : 1,
                }}
                theme="twoTone"
                twoToneColor="#ff3333"
                type="delete"
                onClick={() => {
                  if (row.templateCounts) return;
                  Modal.confirm({
                    title: 'Delete this Email Type ?',
                    content: 'This operation can take some time',
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    onOk: () => mutate(row.id),
                  });
                }}
              />
            </Tooltip>
          </PermissionGuard>
        );
      },
    },
  ];
  return (
    <Table
      columns={columnDefs}
      dataSource={emailTypes}
      loading={isLoading}
      pagination={false}
      rowKey="id"
    />
  );
}
